<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Patrocinadores</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Patrocinadores</div>
        </div>
      </div>

      <!-- Vazio -->
      <div v-if="!list.length" class="appui-emptystate">
        <div class="appui-emptystate-icon"><i class="bx bx-briefcase-alt-2"></i></div>
        <div class="appui-emptystate-title">Nenhum patrocinador ainda</div>
        <div class="appui-emptystate-sub">Cadastre patrocinadores e expositores por cota (Ouro, Prata...) — cada um com estande próprio no app.</div>
        <button class="appui-btn appui-btn--primary" @click="openCreate()">+ Adicionar o primeiro patrocinador</button>
      </div>

      <!-- Bloco principal -->
      <section v-else class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left">
            <span class="appui-toolbar-hint"><i class="mdi mdi-drag-vertical"></i> Arraste para reordenar a exibição no app.</span>
          </div>
          <div class="appui-card-toolbar-right">
            <button class="appui-btn appui-btn--ghost" @click="categoryModal = true"><i class="mdi mdi-tag-multiple-outline mr-1"></i> Cotas</button>
            <button class="appui-btn appui-btn--primary" @click="openCreate()">+ Novo patrocinador</button>
          </div>
        </div>

        <table class="appui-table">
          <thead><tr><th style="width:46px"></th><th>Patrocinador</th><th style="width:150px">Cota</th><th style="width:80px">Ativo</th><th style="width:250px;text-align:right">Ações</th></tr></thead>
          <draggable
            v-model="list"
            :element="'tbody'"
            :options="{ animation: 180, handle: '.appui-grip', ghostClass: 'appui-drag-ghost' }"
            @end="reorder"
          >
            <tr v-for="p in list" :key="p.id">
              <td><span class="appui-grip" title="Arraste para reordenar">⠿</span></td>
              <td>
                <div style="display:flex;align-items:center;gap:12px">
                  <span class="appui-avatar" style="width:44px;height:32px;font-size:12px;background:#f7f8fa">
                    <img v-if="p.logo" :src="p.logo" style="object-fit:contain"><template v-else><i class="bx bx-briefcase-alt-2"></i></template>
                  </span>
                  <span style="font-weight:500;color:#495057">{{ p.name }}</span>
                </div>
              </td>
              <td>
                <span v-if="p.category" class="appui-badge" :style="{ background: (p.category.color || '#74788d') + '22', color: p.category.color || '#74788d' }">{{ p.category.name }}</span>
                <span v-else style="color:#adb5bd">—</span>
              </td>
              <td><button class="appui-switch" :class="{ 'is-on': p.status }" @click="toggle(p)"><span class="knob"></span></button></td>
              <td style="text-align:right;white-space:nowrap">
                <button class="appui-tbtn appui-tbtn--primary" style="margin-right:6px" @click="manage(p)"><i class="mdi mdi-folder-multiple-outline"></i> Conteúdo</button>
                <button class="appui-tbtn" style="margin-right:6px" @click="openEdit(p)">Editar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="remove(p)">Excluir</button>
              </td>
            </tr>
          </draggable>
        </table>
      </section>
    </div>

    <!-- Modal patrocinador -->
    <b-modal v-model="showModal" :title="form.id ? 'Editar patrocinador' : 'Novo patrocinador'" size="lg" hide-footer>
      <form @submit.prevent="save()">
        <div class="row">
          <div class="col-sm-5">
            <label class="appui-label">Logo</label>
            <input type="file" accept="image/*" ref="logo" style="display:none" @change="onImg('logo', $event)">
            <div class="appui-drop" :class="{ 'has-img': preview.logo }" style="min-height:110px" @click="$refs.logo.click()">
              <template v-if="preview.logo">
                <img :src="preview.logo" class="appui-drop-img" style="max-height:86px">
                <div class="appui-drop-overlay"><span class="appui-drop-btn"><i class="mdi mdi-swap-horizontal"></i> Trocar</span></div>
              </template>
              <template v-else>
                <i class="mdi mdi-cloud-upload-outline appui-drop-icon" style="font-size:30px"></i>
                <span class="appui-drop-hint">Logo · até 1 MB</span>
              </template>
            </div>
          </div>
          <div class="col-sm-7">
            <label class="appui-label">Banner do estande</label>
            <input type="file" accept="image/*" ref="header" style="display:none" @change="onImg('header', $event)">
            <div class="appui-drop" :class="{ 'has-img': preview.header }" style="min-height:110px" @click="$refs.header.click()">
              <template v-if="preview.header">
                <img :src="preview.header" class="appui-drop-img" style="max-height:86px">
                <div class="appui-drop-overlay"><span class="appui-drop-btn"><i class="mdi mdi-swap-horizontal"></i> Trocar</span></div>
              </template>
              <template v-else>
                <i class="mdi mdi-cloud-upload-outline appui-drop-icon" style="font-size:30px"></i>
                <span class="appui-drop-hint">Banner · até 2 MB</span>
              </template>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top:14px">
          <div class="form-group col-sm-8"><label>Nome *</label><input type="text" class="form-control" v-model="form.name" required></div>
          <div class="form-group col-sm-4">
            <label>Cota</label>
            <select class="custom-select" v-model="form.partner_category_id"><option :value="null">—</option><option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</option></select>
          </div>
        </div>
        <div class="form-group">
          <label>Sobre</label>
          <ckeditor :editor="editor" v-model="form.about" :config="editorConfig"></ckeditor>
        </div>
        <div class="row">
          <div class="form-group col-sm-6" v-for="soc in socials" :key="soc.key"><label>{{ soc.label }}</label><input type="url" class="form-control" v-model="form[soc.key]" placeholder="https://..."></div>
        </div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="showModal = false">Cancelar</button><button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button></div>
      </form>
    </b-modal>

    <!-- Modal cotas/categorias (nome + cor) -->
    <b-modal v-model="categoryModal" title="Cotas de patrocínio" hide-footer>
      <form class="d-flex mb-3" style="gap:8px" @submit.prevent="saveCategory()">
        <input type="text" class="form-control" v-model.trim="categoryForm.name" :placeholder="categoryForm.id ? 'Renomear cota' : 'Nova cota (ex: Ouro)'" required>
        <input type="color" class="form-control" style="width:52px;padding:3px;flex:none" v-model="categoryForm.color" title="Cor da cota">
        <button type="submit" class="btn btn-primary" style="flex:none">{{ categoryForm.id ? 'Salvar' : 'Adicionar' }}</button>
        <button v-if="categoryForm.id" type="button" class="btn btn-light" style="flex:none" @click="resetCategoryForm()">Cancelar</button>
      </form>
      <table class="appui-table">
        <tbody>
          <tr v-for="c in categories" :key="c.id">
            <td class="appui-link" title="Clique para editar" @click="categoryForm = { id: c.id, name: c.name, color: c.color || '#556ee6' }">
              <span style="display:inline-block;width:14px;height:14px;border-radius:4px;vertical-align:-2px;margin-right:8px" :style="{ background: c.color || '#ccc' }"></span>{{ c.name }}
            </td>
            <td style="width:50px;text-align:right">
              <button class="appui-icon-btn appui-icon-btn--danger" @click="removeCategory(c)"><i class="mdi mdi-trash-can-outline"></i></button>
            </td>
          </tr>
          <tr v-if="!categories.length"><td colspan="2" class="appui-empty">Nenhuma cota.</td></tr>
        </tbody>
      </table>
      <div class="text-right" style="margin-top:12px"><button class="btn btn-light" @click="categoryModal = false">Fechar</button></div>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

const empty = () => ({ id: null, name: '', partner_category_id: null, about: '', facebook: '', instagram: '', linkedin: '', youtube: '', website: '', twitter: '' })

export default {
  components: { draggable, ckeditor: CKEditor.component },
  name: 'app-partners',
  data () {
    return {
      list: [],
      categories: [],
      editor: ClassicEditor,
      editorConfig: { toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'undo', 'redo'] },
      showModal: false,
      saving: false,
      form: empty(),
      files: { logo: null, header: null },
      preview: { logo: null, header: null },
      categoryModal: false,
      categoryForm: { id: null, name: '', color: '#556ee6' },
      socials: [
        { key: 'website', label: 'Website' },
        { key: 'instagram', label: 'Instagram' },
        { key: 'linkedin', label: 'LinkedIn' },
        { key: 'facebook', label: 'Facebook' },
        { key: 'youtube', label: 'YouTube' },
        { key: 'twitter', label: 'Twitter / X' }
      ]
    }
  },
  mounted () { this.load(); this.loadCategories() },
  methods: {
    load () {
      const loader = this.$loading.show()
      services.listPartners().then(r => { this.list = r.data.data }).catch(() => errorMessage('Falha ao carregar patrocinadores.', 3000)).finally(() => loader.hide())
    },
    loadCategories () { services.listPartnerCategories().then(r => { this.categories = r.data.data }).catch(() => {}) },
    resetCategoryForm () { this.categoryForm = { id: null, name: '', color: '#556ee6' } },
    async saveCategory () {
      if (!this.categoryForm.name) return
      try {
        const payload = { name: this.categoryForm.name, color: this.categoryForm.color }
        if (this.categoryForm.id) await services.updatePartnerCategory(this.categoryForm.id, payload)
        else await services.createPartnerCategory(payload)
        this.resetCategoryForm()
        this.loadCategories()
        this.load()
      } catch (e) { errorMessage('Falha ao salvar cota.', 3000) }
    },
    async removeCategory (c) {
      const ok = await this.$bvModal.msgBoxConfirm(`Remover a cota "${c.name}"?`, { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deletePartnerCategory(c.id); this.loadCategories(); this.load() } catch (e) { errorMessage(e?.response?.data?.message || 'Falha ao remover cota.', 3500) }
    },
    openCreate () { this.form = empty(); this.files = { logo: null, header: null }; this.preview = { logo: null, header: null }; this.showModal = true },
    openEdit (p) {
      this.form = { ...empty(), ...p, about: p.about || '' }
      this.files = { logo: null, header: null }
      this.preview = { logo: p.logo, header: p.header }
      this.showModal = true
    },
    onImg (field, e) {
      const f = e.target.files[0]
      e.target.value = ''
      if (!f) return
      const limit = field === 'logo' ? 1 : 2
      if (!f.type.startsWith('image/')) { errorMessage('Envie um arquivo de imagem.', 2500); return }
      if (f.size > limit * 1024 * 1024) { errorMessage(`A imagem deve ter no máximo ${limit} MB.`, 2500); return }
      this.files[field] = f
      this.preview[field] = URL.createObjectURL(f)
    },
    async save () {
      this.saving = true
      try {
        const fd = new FormData()
        Object.keys(empty()).forEach(k => { if (k !== 'id' && this.form[k] != null) fd.append(k, this.form[k]) })
        if (this.files.logo) fd.append('logo', this.files.logo)
        if (this.files.header) fd.append('header', this.files.header)
        if (this.form.id) await services.updatePartner(this.form.id, fd)
        else await services.createPartner(fd)
        this.showModal = false
        successMessage('Patrocinador salvo.', 2000)
        this.load()
      } catch (e) { errorMessage('Falha ao salvar.', 3000) } finally { this.saving = false }
    },
    async toggle (p) { try { await services.changePartnerStatus(p.id); p.status = p.status ? 0 : 1 } catch (e) { errorMessage('Falha ao alterar status.', 3000) } },
    async remove (p) {
      const ok = await this.$bvModal.msgBoxConfirm(`Remover "${p.name}"?`, { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deletePartner(p.id); this.load() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    manage (p) { this.$router.push(`/app/partners/${p.id}`) },
    async reorder () {
      try { await services.reorderPartners(this.list.map(it => ({ id: it.id }))) } catch (e) { errorMessage('Falha ao reordenar.', 3000); this.load() }
    }
  }
}
</script>
